// import { darken, lighten, normalize } from 'polished'
import { Flex } from '@rebass/grid'
import { Card, Divider } from 'antd'
import React from 'react'
import styled, { css } from 'styled-components'
import { omit } from '../utils'
// import GlobeIcon from '../assets/globe.svg'
import Arrow from '../assets/arrow.svg'
import CheckIcon from '../assets/check.svg'
import ErrorIcon from '../assets/error.svg'
import PsLogo from '../assets/platforms/ps.svg'
import SteamLogo from '../assets/platforms/steam.svg'
import XboxLogo from '../assets/platforms/xbox.svg'

const styledf = propsToOmit => tag => (...args) => {
  const Elem = styled(tag)``

  return styled(props => <Elem {...omit(props, propsToOmit)} />).call(
    styled,
    ...args
  )
}

const StyledFlex = styled(({ fullWidth, fullHeight, ...p }) => <Flex {...p} />)`
  position: relative;
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
  height: ${p => (p.fullHeight ? '100%' : 'auto')};
`

StyledFlex.defaultProps = {
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
}

const MediaSizes = {
  desktop: 1920,
  phone: 568,
}

export const Icons = {
  Check: CheckIcon,
  Error: ErrorIcon,
  Xbox: XboxLogo,
  Steam: SteamLogo,
  Playstation: PsLogo,
  // Globe: GlobeIcon,
  Arrow,
}

// Iterate through the sizes and create a media template
export const MediaTemplates = Object.keys(MediaSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${MediaSizes[label] / 16}em) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const StyledAnchor = styled.a`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`

/* export const AppColors = {
  main: '#1c392b',
  links: '#1890ff',
  textWhite: '#fff',
  textOffwhite: '#eee',
  textGrey: '#b9c9da',
  offBlack: '#121212',
  blue2: '#131a27',
  darkBlue: '#1c2f48',
  darkerBlue: '#152336',
  error: '#946363',
  antLink: '#1890ff',
  primary: '#1890ff',
  primaryLight: '#006dd2', DOES NOT EXIST IN SANITY
  textTransBlack: 'rgba(0,0,0,0.55)',
  button2: '#1a9484',
} */

const CellFlex = styled(Flex)`
  width: 100%;
  height: 100%;
`

CellFlex.defaultProps = {
  justifyContent: 'center',
  alignItems: 'center',
}

const NewCell = props => <CellFlex {...props}>{props.children}</CellFlex>

export const WrapPadding = 100

export const WrapWidth = 8 / 12

const NewDivider = styled(Divider)`
  ${({ color }) => color && `background: ${color}`};
  &.ant-divider {
    &:before,
    &:after {
      border-top-color: ${p => p.theme.textOffwhite};
    }
  }
`

const NewCard = styled(Card)`
  background: #bbb;
`

/* const styledf = (propsToOmit, Elem) =>
  styled(props => <Elem {...omit(props, propsToOmit)} />) */

export { styledf }
export { StyledFlex as Flex }
export { NewCell as Cell }
export { NewDivider as Divider }
export { NewCard as Card }



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/styled-common.js